import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStep4 } from "./../../models/classes/ApplicationStep4.class";

export interface ApplicationStep4States {
  formData: ApplicationStep4;
}

const initialState: ApplicationStep4States = {
  formData: new ApplicationStep4(),
};

const ApplicationStep4Slice = createSlice({
  name: "Application Step 4 Slice",
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<ApplicationStep4>) => {
      console.log("Redux ApplicationStep4.updateFormData triggered")
      console.log("action.payload", action.payload)
      state.formData = action.payload;
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStep4();
    }
  },
  extraReducers: {},
});

export const { updateFormData, resetFormData } = ApplicationStep4Slice.actions;

export default ApplicationStep4Slice.reducer;
